import L from 'leaflet';
import 'leaflet.markercluster';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import 'theme/moydom/less/pages/spravochnik.less';
import _ from 'lodash';
import {leafetLayer} from 'ui/map/config';
import {Map} from './Map';
import { GestureHandling } from 'leaflet-gesture-handling';
import 'leaflet-gesture-handling/dist/leaflet-gesture-handling.css';

interface ConfigOptions {
    center?: any,
    gestureHandling?: boolean,
}

export class MapBuilder {
    private _layer() {
        return _.clone(leafetLayer);
    }

    private _style() {
        return {
            color: '#0061d9',
            fillColor: '#CBDEFF',
            opacity: 0.5,
            fillOpacity: 0.33,
            weight: 5,
        };
    }

    private _onClickByIcon: () => void = () => {};

    constructor(
        private element: Element,
        private options: ConfigOptions = {}
    ) { }

    applyStyle() {
        const myStyle = this._style();
        L.Path.mergeOptions(myStyle);
        L.Polyline.mergeOptions(myStyle);
        L.Polygon.mergeOptions(myStyle);
        L.Rectangle.mergeOptions(myStyle);
        L.Circle.mergeOptions(myStyle);
        L.CircleMarker.mergeOptions(myStyle);
    }

    private _useClustering() {
        // this.markers = L.markerClusterGroup({
        //     maxClusterRadius: 10,
        //     showCoverageOnHover: true,
        // });
        // this.map.addLayer(this.markers);
    }


    onClickByLayer(on: () => void) {
        this._onClickByIcon = on;
    }

    useDefaultCenter() {
        this.options.center = (window as any).BaseApp.initData.center;
    }

    useGestureHandling() {
        this.options.gestureHandling = true;
        L.Map.addInitHook('addHandler', 'gestureHandling', GestureHandling);
    }

    makeDefault(): Map {
        this.applyStyle();
        this.useDefaultCenter();
        this.useGestureHandling();

        const baseLayer = this._layer();

        const map = new L.Map(this.element, {
            center: this.options.center,
            gestureHandling: this.options?.gestureHandling,
            zoom: 13,
            zoomControl: false,
            layers: [baseLayer]
        });
        // const markers = L.markerClusterGroup({
        //     maxClusterRadius: 10,
        //     showCoverageOnHover: true,
        // });

        baseLayer.addTo(map);

        let bounds = (window as any).BaseApp.initData.mapConfig.bounds || null;

        if (bounds) {
            bounds = L.latLngBounds(
                [bounds.leftTop.y, bounds.leftTop.x],
                [bounds.rightBottom.y, bounds.rightBottom.x]
            );

            map.setMaxBounds(bounds);
        }

        const minZoom = (window as any).BaseApp.initData.mapConfig.minZoom || null;
        const maxZoom = (window as any).BaseApp.initData.mapConfig.maxZoom || null;

        if (minZoom){
            map.setMinZoom(minZoom);
        }

        if (maxZoom){
            map.setMaxZoom(maxZoom);
        }

        // this.markers.on('click', (e) => {
        //     this.config.event.onChoiceElem([JSON.parse(e.layer.object.geoObject).properties.id]);
        // });

        const _map = new Map(this.element, map);
        _map.resizeObserver();

        return _map;
    }


}
